import ComingSoonModal from './ComingSoonModal';

export default ComingSoonModal;
